var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./SettingsBaseView.njk"] = require( "./SettingsBaseView.njk" );




var shim = require("/codebuild/output/src2118274201/src/tv-monitor-ui/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/js/view/pages/settings/DisplayConfigurationView.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("./SettingsBaseView.njk", true, "src/js/view/pages/settings/DisplayConfigurationView.njk", false, function(t_2,_parentTemplate) {
if(t_2) { cb(t_2); return; }
parentTemplate = _parentTemplate
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("breadcrumb"))(env, context, frame, runtime, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
output += t_3;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("actions"))(env, context, frame, runtime, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
output += t_5;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_breadcrumb(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <a href=\"#settings\">Your Xola TV displays</a> > Configure display\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_actions(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "<img class=\"spinner hidden\" src=\"img/spinner.gif\" />";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"display-information form-horizontal\">\n        <h2>Display Information</h2>\n\n        <div class=\"form-group\">\n            <label for=\"name\" class=\"col-sm-2 control-label\">Name</label>\n            <div class=\"col-sm-6\">\n                <input type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"Retail Lobby Display\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">Url</label>\n            <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
output += "\" target=\"_blank\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
output += "</a>\n                ";
;
}
else {
output += "\n                    <i>Save the configuration to generate URL</i>\n                ";
;
}
output += "\n                </p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"appearance form-horizontal\">\n        <h2>Appearance</h2>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">Background</label>\n            <div class=\"col-sm-6\">\n                <div class=\"radio ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundType") == "color") {
output += "active";
;
}
output += "\">\n                    <label>\n                        <input type=\"radio\" name=\"header-backgroundType\" id=\"header-backgroundColor\" value=\"color\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundType") == "color") {
output += "checked";
;
}
output += ">\n                        Color\n                    </label>\n\n                    <div class=\"subgroup\">\n                        <label>\n                            <input id=\"config-header-backgroundColor\" type=\"color\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundColor"), env.opts.autoescape);
output += "\" />\n                        </label>\n                    </div>\n                </div>\n                <div class=\"radio ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundType") == "image") {
output += "active";
;
}
output += "\">\n                    <label>\n                        <input type=\"radio\" name=\"header-backgroundType\" id=\"header-backgroundImage\" value=\"image\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundType") == "image") {
output += "checked";
;
}
output += ">\n                        Image\n                    </label>\n\n                    <div class=\"subgroup\">\n                        <label>\n                            <div id=\"background-preview\"></div>\n\n                            <input type=\"file\" size=\"20\" id=\"config-header-backgroundImage\" name=\"config-header-backgroundImage\">\n                        </label>\n\n                        <div class=\"form-group\">\n                            <div class=\"col-sm-12\">\n                                <select class=\"form-control\" id=\"config-header-backgroundSize\" name=\"config-header-backgroundSize\">\n                                    <option value=\"cover\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundSize") == "cover") {
output += "selected";
;
}
output += ">Cover</option>\n                                    <option value=\"contain\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"backgroundSize") == "contain") {
output += "selected";
;
}
output += ">Contain</option>\n                                </select>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">Text Color</label>\n            <div class=\"col-sm-10 color-picker\">\n                <input id=\"config-header-textColor\" type=\"color\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"textColor"), env.opts.autoescape);
output += "\" />\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-header-logoImage\" class=\"col-sm-2 control-label\">Logo</label>\n            <div class=\"col-sm-10\">\n                <label>\n                    <div id=\"logo-preview\">\n                        <img height=\"100px\" src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "logoPreviewUrl"), env.opts.autoescape);
output += "\">\n                    </div>\n\n                    <input type=\"file\" size=\"20\" id=\"config-header-logoImage\" name=\"config-header-logoImage\">\n                </label>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-header-logoSize\" class=\"col-sm-2 control-label\">Logo Size</label>\n            <div class=\"col-sm-6\">\n                <select class=\"form-control\" id=\"config-header-logoSize\" name=\"config-header-logoSize\">\n                    <option value=\"2em\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"logoSize") == "2em") {
output += "selected";
;
}
output += ">Small</option>\n                    <option value=\"3em\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"logoSize") == "3em") {
output += "selected";
;
}
output += ">Medium</option>\n                    <option value=\"4em\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"header")),"logoSize") == "4em") {
output += "selected";
;
}
output += ">Large</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"filtering form-horizontal\">\n        <h2>Filtering</h2>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-listings\" class=\"col-sm-2 control-label\">Listings</label>\n            <div class=\"col-sm-10 region-experience-selector\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-capacity\" class=\"col-sm-2 control-label\">Capacity</label>\n            <div class=\"col-sm-6\">\n                <select class=\"form-control\" id=\"config-events-capacity\" name=\"config-events-capacity\">\n                    <option value=\"available\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"capacity") == "available") {
output += "selected";
;
}
output += ">Show only available events</option>\n                    <option value=\"reserved\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"capacity") == "reserved") {
output += "selected";
;
}
output += ">Show only reserved events</option>\n                    <option value=\"all\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"capacity") == "all") {
output += "selected";
;
}
output += ">Show all events</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-showTomorrowsEvents\" class=\"col-sm-2 control-label\">Time</label>\n            <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" id=\"config-events-showTomorrowsEvents\" name=\"config-events-showTomorrowsEvents\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"showTomorrowsEvents")) {
output += "checked";
;
}
output += "> Show tomorrow's events\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-hideTimeout\" class=\"col-sm-2 control-label\"></label>\n            <div class=\"col-sm-6\">\n                <select class=\"form-control\" id=\"config-events-hideTimeout\" name=\"config-events-hideTimeout\">\n                    <option value=\"-5\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "-5") {
output += "selected";
;
}
output += ">Hide events 5 minutes before they start</option>\n                    <option value=\"0\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "0") {
output += "selected";
;
}
output += ">Hide events when they start</option>\n                    <option value=\"15\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "15") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events 15 minutes after they start</option>\n                    <option value=\"30\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "30") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events 30 minutes after they start</option>\n                    <option value=\"45\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "45") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events 45 minutes after they start</option>\n                    <option value=\"60\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "60") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events 1 hour after they start</option>\n                    <option value=\"120\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "120") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events 2 hours after they start</option>\n                    <option value=\"180\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "180") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events 3 hours after they start</option>\n                    <option value=\"eventEnd\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "eventEnd") {
output += "selected";
;
}
output += " class=\"event-dependant\">Hide events when they end</option>\n                    <option value=\"dayEnd\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"hideTimeout") == "dayEnd") {
output += "selected";
;
}
output += ">Don't hide today's events</option>\n                </select>\n                <p class=\"help-block\">Some options are unavailable when showing \"Only available events\".</p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"event-summary form-horizontal\">\n        <h2>Event Summary</h2>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-availability\" class=\"col-sm-2 control-label\">Availability</label>\n            <div class=\"col-sm-6\">\n                <select class=\"form-control\" id=\"config-events-availability\" name=\"config-events-availability\">\n                    <option value=\"available\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"availability") == "available") {
output += "selected";
;
}
output += ">Show number of available slots</option>\n                    <option value=\"reserved\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"availability") == "reserved") {
output += "selected";
;
}
output += ">Show number of reserved slots</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-availabilityBlink\" class=\"col-sm-2 control-label\"></label>\n            <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" id=\"config-events-availabilityBlink\" name=\"config-events-availabilityBlink\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"availabilityBlink")) {
output += "checked";
;
}
output += "> Blink availability for events that are almost full\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-showDuration\" class=\"col-sm-2 control-label\">Duration</label>\n            <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" id=\"config-events-showDuration\" name=\"config-events-showDuration\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"showDuration")) {
output += "checked";
;
}
output += "> Display event duration\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-showGuides\" class=\"col-sm-2 control-label\">Guides</label>\n            <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" id=\"config-events-showGuides\" name=\"config-events-showGuides\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"showGuides")) {
output += "checked";
;
}
output += "> Display assigned guides\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-showDemographics\" class=\"col-sm-2 control-label\">Demographics</label>\n            <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" id=\"config-events-showDemographics\" name=\"config-events-showDemographics\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"showDemographics")) {
output += "checked";
;
}
output += "> Display demographic breakdown\n                    </label>\n                </div>\n                <p class=\"help-block\">Can only be changed when showing \"Only reserved events\".</p>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"config-events-showPrice\" class=\"col-sm-2 control-label\">Price</label>\n            <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" id=\"config-events-showPrice\" name=\"config-events-showPrice\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"showPrice")) {
output += "checked";
;
}
output += "> Display price\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_breadcrumb: b_breadcrumb,
b_actions: b_actions,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/js/view/pages/settings/DisplayConfigurationView.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/js/view/pages/settings/DisplayConfigurationView.njk
// module id = 249
// module chunks = 0